import React, { useState, useRef } from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import HandleHttpErrors from "../HandleHttpErrors";
import { Modal } from "react-bootstrap";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import listPlugin from "@fullcalendar/list";
import heLocale from "@fullcalendar/core/locales/he";

const baseURL = process.env.REACT_APP_API_JOBS;

function BhinaMeetingCalendarModal({
  showMeetingsCalender,
  setShowMeetingsCalender,
}) {
  const [events, setEvents] = useState([]);
  const axiosPrivate = useAxiosPrivate("application/json");
  const isMounted = useRef(true);
  const fetchEvents = async (startDate, endDate) => {
    try {
      const response = await axiosPrivate.get(
        `${baseURL}bhinameetingevents/?startdate=${startDate}&enddate=${endDate}`
      );

      if (isMounted.current) {
        const formattedEvents = response.data.map((event) => {
          const eventStart = new Date(`${event.mt_date}T${event.start_time}`);
          const currentDate = new Date();
          // Determine background color based on whether the event is in the past or future
          // const backgroundColor = eventStart < currentDate ? "blue" : "green";

          return {
            title: event.mkh_title + " " + event.mkh_num,
            start: `${event.mt_date}T${event.start_time}`,
            end: event.end_time ? `${event.mt_date}T${event.end_time}` : null, // Handling null end time
            //backgroundColor: backgroundColor,
          };
        });
        setEvents(formattedEvents);
        console.log("Formatted Events:", formattedEvents);
      }
    } catch (err) {
      if (err.response) {
        alert(HandleHttpErrors(err.response.status));
      } else if (err.request) {
        alert(
          "The client never received a response, and the request was never left"
        );
      } else {
        alert("An unknown error occurred");
      }
    }
  };

  return (
    <Modal
      show={showMeetingsCalender}
      onHide={() => setShowMeetingsCalender(false)}
      backdrop="static"
      keyboard={false}
      size="xl"
    >
      <Modal.Header className="mx-auto" closeButton>
        <Modal.Title>לו"ז ישיבות ועדות הבחינה</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ backgroundColor: "#d0e7f9" }}>
        <FullCalendar
          plugins={[dayGridPlugin, timeGridPlugin, listPlugin]}
          initialView="dayGridMonth"
          firstDay={0}
          locale={heLocale} // Set Hebrew locale
          headerToolbar={{
            left: "prev,next today",
            center: "title",
            right: "dayGridMonth,timeGridWeek,timeGridDay",
          }}
          events={events}
          eventContent={(eventInfo) => (
            <div>
              <b>{eventInfo.event.title}</b>
            </div>
          )}
          datesSet={(dateInfo) => {
            console.log(dateInfo.startStr);
            const start = new Date(dateInfo.startStr)
              .toISOString()
              .split("T")[0];
            const end = new Date(dateInfo.endStr).toISOString().split("T")[0];
            fetchEvents(start, end);
          }}
        />
      </Modal.Body>
    </Modal>
  );
}

export default BhinaMeetingCalendarModal;
